export default (state) => {
  state.currentAdministrator.citationsReport.items = [];
  state.currentAdministrator.citationsReport.isFetching = true;
  state.currentAdministrator.citationsReport.totalCount = null;
};
